import { createFileRoute } from "@tanstack/react-router";
import { RelatorioColetasCidade } from "pages/relatorios/pages/coletas_cidade";

export const Route = createFileRoute("/a/relatorios/coletas-cidade")({
	component: RelatorioColetasCidade,
});
